/**
 * Sfondi area principale dashboard palestra (GymDashboard).
 * Tenere allineate le pagine pubbliche (es. login) quando si vuole continuità visiva.
 */
export const DASHBOARD_BG_LIGHT =
  'linear-gradient(90deg, #FDFDFE 0%, #E5DFF1 100%)';

/** Sfondo dark neutro (allineato a gymPageTheme / gray-950) */
export const DASHBOARD_BG_DARK =
  'linear-gradient(165deg, #030712 0%, #111827 50%, #1f2937 100%)';
